import reduce from 'lodash/reduce';
import installation from '~/modules/installation/reactions';
import modal from '~/modules/modal/reactions';
import user from '~/modules/user/reactions';
import recentSearches from '~/modules/recentSearches/reactions';
import queriedLoads from '~/modules/queriedLoads/reactions';
import saferwatch from '~/modules/saferwatch/reactions';
import loads from '~/modules/loads/reactions';
import backhaul from '~/modules/backhaul/reactions';
import brokers from '~/modules/brokers/reactions';
import tips from '~/modules/tips/reactions';

const reactionsByActionType = reduce(
  [
    installation,
    modal,
    user,
    recentSearches,
    queriedLoads,
    saferwatch,
    loads,
    backhaul,
    brokers,
    tips,
  ],
  (accumulator, subindex) =>
    reduce(subindex, (subacc, items, key) => ({
      ...subacc,
      [key]: (subacc[key] || []).concat(items),
    }), accumulator)
  , {});

const reactions = (store) => (nextDispatch) => (action) => {
  if (!reactionsByActionType[action.type]) {
    nextDispatch(action);
    return;
  }

  const prevState = store.getState();
  nextDispatch(action);

  reactionsByActionType[action.type].forEach((doReaction) => {
    const actions = doReaction(action, store, prevState);
    if (!actions) {
      return;
    }

    if (!Array.isArray(actions)) {
      store.dispatch(actions);
      return;
    }

    actions.forEach(item => store.dispatch(item));
  });
};

export default reactions;



// WEBPACK FOOTER //
// ./src/middlewares/reactions.js